<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">
      Récurrence personnalisée
    </div>
    <div class="modal-body">
      <div class="body-content">
        <div class="repeat-offset-wrapper">
          <div class="label">Répéter tou(te)s les</div>
          <div class="offset-values-wrapper">
            <input class="offset-input" *ngIf="formGroup" [formControl]="formGroup.get('offset')" type="number" min="1">
            <frg-form-input *ngIf="formGroup" id="unit" [selectValue]="unitArray" type="text" [formGroup]="formGroup"
              [control]="formGroup.get('unit')"></frg-form-input>
          </div>
        </div>
        <!-- Affichage si l'unité de récurrence est en semaines -->
        <div class="days-wrapper" *ngIf="formGroup.get('unit').value === 'semaine(s)'">
          <div class="day-label title">Le</div>
          <div class="day-values">
            <div *ngFor="let day of daysInWeek"
              (click)="formGroup.get('dayOfWeek').value.includes(day.value) ? removeDay(day) : addDay(day)"
              class="day-label-container"
              [ngClass]="{ 'selected': formGroup.get('dayOfWeek').value.includes(day.value) }">
              <span class="day-label">{{ day.label }}</span>
            </div>
          </div>
        </div>

        <!-- Affichage si l'unité de récurrence est en mois -->
        <div class="days-wrapper" *ngIf="formGroup.get('unit').value === 'moi(s)'">
          <div class="day-label title">Le</div>
          <div class="day-values with-input">
            <frg-form-input *ngIf="formGroup" id="monthUnitLabel" [selectValue]="unitMonthSelectLabel" type="text" [formGroup]="formGroup"
              [control]="formGroup.get('monthUnitLabel')"></frg-form-input>
          </div>
        </div>

        <div class="recur-end">
          <div class="recur-end-label" *ngIf="formGroup">Se termine</div>
          <div class="radio-wrapper">
            <input type="radio" name="recur-end" [formControl]="formGroup.get('endType')" value="never">
            <div class="radio-label">
              <span class="label-wording">Jamais</span>
            </div>
          </div>
          <div class="radio-wrapper">
            <input type="radio" name="recur-end" [formControl]="formGroup.get('endType')" value="date">
            <div class="radio-label">
              <span class="label-wording">Le</span>
              <frg-form-input id="endDate" type="date" [formGroup]="formGroup" [control]="formGroup.get('endDate')"></frg-form-input>
            </div>
          </div>
          <div class="radio-wrapper">
            <input type="radio" *ngIf="formGroup" name="recur-end" [formControl]="formGroup.get('endType')" value="ocurrenceNumber">
            <div class="radio-label">
              <span class="label-wording">Après</span>
              <input class="label-input-number" *ngIf="formGroup" [formControl]="formGroup.get('endOcurrenceNumber')" type="number" min="1">
              <span class="label-wording">fois</span>
            </div>
          </div>
        </div>

        <div class="checkbox-container">
          <div class="checkbox-wrapper">
            <label class="checkbox">
              <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('keepPatient')" (change)="keepInfos(formGroup.get('keepPatient'), $event.target.checked)" type="checkbox">
              <span class="checkMark"></span>
            </label>
            <div class="label">Conserver informations patient</div>
          </div>
          <div class="checkbox-wrapper">
            <label class="checkbox">
              <input *ngIf="formGroup" [formGroup]="formGroup" [formControl]="formGroup.get('keepDescription')" (change)="keepInfos(formGroup.get('keepDescription'), $event.target.checked)" type="checkbox">
              <span class="checkMark"></span>
            </label>
            <div class="label">Conserver description du RDV</div>
          </div>
        </div>
      </div>
      <div class="button-wrapper" *ngIf="formGroup">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal(null)">Annuler</frg-button>
        <frg-button backgroundColor="var(--primary)" (activated)="saveRecurrence()" [disabled]="!formGroup.valid">Valider</frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>